import { render, staticRenderFns } from "./DisasterNameManagement.vue?vue&type=template&id=570f1628&"
import script from "./DisasterNameManagement.vue?vue&type=script&lang=js&"
export * from "./DisasterNameManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports